import { render, staticRenderFns } from "./SendersDomainCreate.vue?vue&type=template&id=aa7443e8&scoped=true&"
import script from "./SendersDomainCreate.vue?vue&type=script&lang=js&"
export * from "./SendersDomainCreate.vue?vue&type=script&lang=js&"
import style0 from "./SendersDomainCreate.vue?vue&type=style&index=0&id=aa7443e8&lang=scss&scoped=true&"
import style1 from "./SendersDomainCreate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7443e8",
  null
  
)

export default component.exports